import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import HomePage from "../HomePage/HomePage";
import About from "../About/About";

import VlogListAllVlogs from "../VlogList/VlogListAllVlogs";
import VlogListLeetCode from "../VlogList/VlogListLeetCode";
import VlogListTechnologyTopics from "../VlogList/VlogListTechnologyTopics";
import VlogListCodeArchitecture from "../VlogList/VlogListCodeArchitecture";
import VlogListTechSeries from "../VlogList/VlogListTechSeries";
import VlogViewerFromUrl from "../VlogViewer/VlogViewerFromUrl";

import { useLocation } from "react-router-dom";

function CustomRoutes() {
  const location = useLocation();

  useEffect(() => {
    // גלול לתחילת הדף כשעוברים לכתובת חדשה
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />

        <Route
          path="/VlogListTechnologyTopics"
          element={<VlogListTechnologyTopics />}
        />
        <Route path="/VlogListAllVlogs" element={<VlogListAllVlogs />} />
        <Route path="/VlogListLeetCode" element={<VlogListLeetCode />} />
        <Route
          path="/VlogListCodeArchitecture"
          element={<VlogListCodeArchitecture />}
        />
        <Route path="/VlogListTechSeries" element={<VlogListTechSeries />} />

        <Route path="/Vlogs/*" element={<VlogViewerFromUrl />} />
        <Route path="/LeetCode/*" element={<VlogViewerFromUrl />} />
        <Route path="/TechSeries/*" element={<VlogViewerFromUrl />} />
      </Routes>
    </>
  );
}

export default CustomRoutes;
